import { AlertTriangle, Trophy } from "lucide-react";

const pct = (v) => (v === null || v === undefined ? null : Math.round(v));

export const CrewRanking = ({ ranking, today, showPlanes = false, testid = "crew-ranking" }) => {
  if (!ranking?.length) return null;
  return (
    <div className="rounded-xl border border-navy/10 bg-white overflow-hidden" data-testid={testid}>
      <div className="px-4 pt-4 pb-2 flex items-center gap-2">
        <Trophy className="w-4 h-4 text-violet" />
        <span className="font-medium text-sm">Avance por cuadrilla — real vs plan</span>
        <span className="ml-auto text-[11px] text-navy/40">corte al {today}</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-navy/10 text-left text-xs text-navy/40">
              {["#", "Cuadrilla", "Cumplimiento", "Avance real vs plan", "Atrasadas", "Próxima entrega", ...(showPlanes ? ["Planes"] : [])].map((h, i) => (
                <th key={i} className="px-3 py-2 font-medium whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ranking.map((d, i) => {
              const c = pct(d.cumplimiento);
              const color = c === null ? "text-navy/40" : c >= 95 ? "text-emerald-600" : c >= 75 ? "text-amber-600" : "text-red-600";
              return (
                <tr key={d.cuadrilla} className="border-b border-navy/5" data-testid={`crew-rank-${d.cuadrilla}`}>
                  <td className="px-3 py-2.5 text-navy/40">{i + 1}</td>
                  <td className="px-3 py-2.5 font-medium whitespace-nowrap">{d.cuadrilla}</td>
                  <td className={`px-3 py-2.5 font-medium whitespace-nowrap ${color}`} data-testid={`crew-cumplimiento-${d.cuadrilla}`}>
                    {c === null ? "Sin exigencia aún" : `${c}%`}
                  </td>
                  <td className="px-3 py-2.5 min-w-[170px]">
                    <div className="space-y-1">
                      <div className="h-1.5 rounded-full bg-navy/10"><div className="h-1.5 rounded-full bg-emerald-500" style={{ width: `${Math.min(d.avance_real, 100)}%` }} /></div>
                      <div className="h-1.5 rounded-full bg-navy/10"><div className="h-1.5 rounded-full bg-navy/30" style={{ width: `${Math.min(d.avance_plan, 100)}%` }} /></div>
                      <div className="text-[10px] text-navy/40">real {d.avance_real}% · plan {d.avance_plan}% ({d.desviacion >= 0 ? "+" : ""}{d.desviacion})</div>
                    </div>
                  </td>
                  <td className="px-3 py-2.5">
                    {d.atrasadas > 0 ? (
                      <span className="inline-flex items-center gap-1 text-xs font-medium text-red-600" title={(d.unidades_atrasadas || []).join("\n")}
                        data-testid={`crew-atrasadas-${d.cuadrilla}`}>
                        <AlertTriangle className="w-3.5 h-3.5" /> {d.atrasadas}
                      </span>
                    ) : <span className="text-xs text-emerald-600">0</span>}
                  </td>
                  <td className="px-3 py-2.5 text-xs text-navy/50 whitespace-nowrap">{d.proxima || "—"}</td>
                  {showPlanes && <td className="px-3 py-2.5 text-xs text-navy/50">{(d.planes || []).join(", ")}</td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
